import { useMemo } from 'react';
import { AvailabilityBlockState } from '@mews-commander/data-access';
import { RouteName } from '@mews-commander/enums';
import { useResolveRoute } from '@mews/routing';
import { useAvailabilityBlock } from './useAvailabilityBlock';

export const useAvailabilityBlockInfo = (availabilityBlockId: string | null | undefined) => {
    const resolveRoute = useResolveRoute();

    const availabilityBlock = useAvailabilityBlock(availabilityBlockId);

    const url = !availabilityBlockId
        ? null
        : resolveRoute(RouteName.AvailabilityBlockDashboard, { availabilityBlockId });

    const state = availabilityBlock?.state;

    return useMemo(
        () => ({
            availabilityBlock,
            url,
            isConfirmed: state === AvailabilityBlockState.Confirmed,
            isCanceled: state === AvailabilityBlockState.Canceled,
            isInquired: state === AvailabilityBlockState.Inquired,
            isOptional: state === AvailabilityBlockState.Optional,
        }),
        [availabilityBlock, state, url]
    );
};
